/* TypeScript file generated from Mona.res by genType. */
/* eslint-disable import/first */


import * as React from 'react';

const $$toJS606672800: { [key: string]: any } = {"0": "Disconnected"};

const $$toRE902960718: { [key: string]: any } = {"Stored": 0, "NotStored": 1};

// @ts-ignore: Implicit any on import
import * as MonaBS__Es6Import from './Mona.bs';
const MonaBS: any = MonaBS__Es6Import;

import type {Item_t as Type_Dropdown_Item_t} from '../../src/type/Type_Dropdown.gen';

import type {Item_value as Type_Dropdown_Item_value} from '../../src/type/Type_Dropdown.gen';

import type {Mona_Button_monaStyle as Atom_Cta_Mona_Button_monaStyle} from '../../src/design-system/atom/Atom_Cta.gen';

import type {Mona_Link_monaLinkStyle as Atom_Cta_Mona_Link_monaLinkStyle} from '../../src/design-system/atom/Atom_Cta.gen';

import type {Mona_autoComplete as Atom_Textfield_Mona_Mona_autoComplete} from '../../src/design-system/atom/Atom_Textfield_Mona.gen';

import type {Mona_disabled as Atom_Cta_Ds_Mona_disabled} from '../../src/design-system/atom/Atom_Cta_Ds.gen';

import type {Mona_variant as Atom_Text_Mona_variant} from '../../src/design-system/atom/Atom_Text.gen';

import type {Select_variant as Organism_Dropdown_Ds_Select_variant} from '../../src/design-system/organism/dropdown/Organism_Dropdown_Ds.gen';

import type {alternativeLanguages as Context_I18n_alternativeLanguages} from '../../src/provider/Context_I18n.gen';

import type {autoComplete as Atom_Select_autoComplete} from '../../src/design-system/atom/Atom_Select.gen';

import type {close as UseToggle_close} from '../../src/hook/UseToggle.gen';

import type {href as Atom_Box_href} from '../../src/design-system/atom/Atom_Box.gen';

import type {htmlFor as Atom_Box_htmlFor} from '../../src/design-system/atom/Atom_Box.gen';

import type {icon as Atom_Icon_Mona_icon} from '../../src/design-system/atom/icon/Atom_Icon_Mona.gen';

import type {initEvents as Entry_Mona_Header_initEvents} from '../../src/entry/Mona/Entry_Mona_Header.gen';

import type {language as Type_Common_language} from '../../src/type/Type_Common.gen';

import type {linkPosition as Molecule_Message_linkPosition} from '../../src/design-system/molecule/Molecule_Message.gen';

import type {link as Molecule_EventInfo_link} from '../../src/design-system/molecule/Molecule_EventInfo.gen';

import type {name as Atom_Box_name} from '../../src/design-system/atom/Atom_Box.gen';

import type {onClick as Atom_Box_onClick} from '../../src/design-system/atom/Atom_Box.gen';

import type {size as Atom_Icon_Ds_size} from '../../src/design-system/atom/Atom_Icon_Ds.gen';

import type {state as Type_DatePicker_state} from '../../src/type/Type_DatePicker.gen';

import type {storage as Molecule_Message_storage} from '../../src/design-system/molecule/Molecule_Message.gen';

import type {target as Atom_Box_target} from '../../src/design-system/atom/Atom_Box.gen';

import type {text as Atom_Box_text} from '../../src/design-system/atom/Atom_Box.gen';

import type {token as User_Type_token} from '../../src/user/User_Type.gen';

import type {type_ as Atom_Box_type_} from '../../src/design-system/atom/Atom_Box.gen';

import type {variant as Atom_Loader_variant} from '../../src/design-system/atom/Atom_Loader.gen';

import type {variant as Molecule_Message_variant} from '../../src/design-system/molecule/Molecule_Message.gen';

/** 
 * @remarks needed to reset styles
 * @example
 * ```javascript
 *  import { globalStyle } from '@artegeie/design-system/mona'
 *  const App = () => { globalStyle() }
 * ```
  */
export const globalStyle: (withFont:boolean) => void = MonaBS.globalStyle;

// tslint:disable-next-line:interface-over-type-literal
export type Icon_Props = {
  readonly icon: Atom_Icon_Mona_icon; 
  readonly size?: Atom_Icon_Ds_size; 
  readonly title?: string
};

/** 
 * @remarks title : a label for screenreaders
 * @example
 * ```javascript
 * import { Icon } from '@artegeie/design-system/mona'
 *
 * const App = () => <Icon icon="Envelope" />
 * ```
 */
export const Icon: React.FC<{
  readonly icon: Atom_Icon_Mona_icon; 
  readonly size?: Atom_Icon_Ds_size; 
  readonly title?: string
}> = function Mona_Icon(Arg1: any) {
  const $props = {icon:typeof(Arg1.icon) === 'object'
    ? Arg1.icon.NAME==="Checked"
      ? {NAME: "Checked", VAL: (Arg1.icon.VAL == null ? undefined : Arg1.icon.VAL)}
      : {NAME: "Tv", VAL: (Arg1.icon.VAL == null ? undefined : Arg1.icon.VAL)}
    : Arg1.icon, size:Arg1.size, title:Arg1.title};
  const result = React.createElement(MonaBS.Icon, $props);
  return result
};

// tslint:disable-next-line:interface-over-type-literal
export type Message_Props = {
  readonly closeLabel: string; 
  readonly id?: string; 
  readonly linkLabel?: string; 
  readonly linkPosition?: Molecule_Message_linkPosition; 
  readonly linkUrl?: Atom_Box_href; 
  readonly storage?: Molecule_Message_storage; 
  readonly text: string; 
  readonly variant: Molecule_Message_variant
};

/** 
 * @remarks closeLabel : a label for screenreaders
 * @example
 * ```javascript
 * import { Message } from '@artegeie/design-system/mona'
 *
 * const App = () => <Message variant="success" closeLabel="close" text="My message text" id=""/>
 * ````
 */
export const Message: React.FC<{
  readonly closeLabel: string; 
  readonly id?: string; 
  readonly linkLabel?: string; 
  readonly linkPosition?: Molecule_Message_linkPosition; 
  readonly linkUrl?: Atom_Box_href; 
  readonly storage?: Molecule_Message_storage; 
  readonly text: string; 
  readonly variant: Molecule_Message_variant
}> = function Mona_Message(Arg1: any) {
  const $props = {closeLabel:Arg1.closeLabel, id:Arg1.id, linkLabel:Arg1.linkLabel, linkPosition:(Arg1.linkPosition == null ? undefined : 0), linkUrl:Arg1.linkUrl, storage:(Arg1.storage == null ? undefined : $$toRE902960718[Arg1.storage]), text:Arg1.text, variant:Arg1.variant};
  const result = React.createElement(MonaBS.Message, $props);
  return result
};

// tslint:disable-next-line:interface-over-type-literal
export type Loader_Props = { readonly label?: string; readonly variant?: Atom_Loader_variant };

export const Loader: React.FC<{ readonly label?: string; readonly variant?: Atom_Loader_variant }> = MonaBS.Loader;

// tslint:disable-next-line:interface-over-type-literal
export type Button_Props = {
  readonly disabled?: Atom_Cta_Ds_Mona_disabled; 
  readonly label: string; 
  readonly onClick?: (_1:MouseEvent) => void; 
  readonly type_?: Atom_Box_type_; 
  readonly variant?: Atom_Cta_Mona_Button_monaStyle
};

/** 
 * @example
 * ```javascript
 * import { Button } from '@artegeie/design-system/mona'
 *
 * const App = () => <Button label="Label" onClick={() => console.log('click')} />
 * ````
 */
export const Button: React.FC<{
  readonly disabled?: Atom_Cta_Ds_Mona_disabled; 
  readonly label: string; 
  readonly onClick?: (_1:MouseEvent) => void; 
  readonly type_?: Atom_Box_type_; 
  readonly variant?: Atom_Cta_Mona_Button_monaStyle
}> = MonaBS.Button;

// tslint:disable-next-line:interface-over-type-literal
export type Typography_Props = {
  readonly children: React.ReactNode; 
  readonly tag?: Atom_Box_text; 
  readonly textRef?: any; 
  readonly variant?: Atom_Text_Mona_variant
};

/** 
 * @example
 * ```javascript
 * import { Typography } from '@artegeie/design-system/mona'
 *
 * const App = () => <Typography variant="title">Hello world</Typography>
 * ```
 */
export const Typography: React.FC<{
  readonly children: React.ReactNode; 
  readonly tag?: Atom_Box_text; 
  readonly textRef?: any; 
  readonly variant?: Atom_Text_Mona_variant
}> = MonaBS.Typography;

/** 
 * @remarks returns all spacers
 * @example
 * ```javascript
 * import { spacers } from '@artegeie/design-system/mona'
 *
 * const App = () => console.log(spacers); // { XXS: "5px", XS: "10px",... }
 * ```
 */
export const spacers: {
  readonly L: string; 
  readonly M: string; 
  readonly None: string; 
  readonly S: string; 
  readonly XL: string; 
  readonly XS: string; 
  readonly XXS: string; 
  readonly Zero: string
} = MonaBS.spacers;

/** 
 * @remarks returns none spacer value
 * @example
 * ```javascript
 * import { noneSpacer } from '@artegeie/design-system/mona'
 *
 * const App = () => console.log(noneSpacer); // "0px"
 * ```
 */
export const noneSpacer: string = MonaBS.noneSpacer;

/** 
 * @remarks returns xxs spacer value
 * @example
 * ```javascript
 * import { xxsSpacer } from '@artegeie/design-system/mona'
 *
 * const App = () => console.log(xxsSpacer); // "5px"
 * ```
 */
export const xxsSpacer: string = MonaBS.xxsSpacer;

/** 
 * @remarks returns xs spacer value
 * @example
 * ```javascript
 * import { xsSpacer } from '@artegeie/design-system/mona'
 *
 * const App = () => console.log(xsSpacer); // "10px"
 * ```
 */
export const xsSpacer: string = MonaBS.xsSpacer;

/** 
 * @remarks returns s spacer value
 * @example
 * ```javascript
 * import { sSpacer } from '@artegeie/design-system/mona'
 *
 * const App = () => console.log(sSpacer); // "15px"
 * ```
 */
export const sSpacer: string = MonaBS.sSpacer;

/** 
 * @remarks returns m spacer value
 * @example
 * ```javascript
 * import { mSpacer } from '@artegeie/design-system/mona'
 *
 * const App = () => console.log(mSpacer); // "25px"
 * ```
 */
export const mSpacer: string = MonaBS.mSpacer;

/** 
 * @remarks returns l spacer value
 * @example
 * ```javascript
 * import { lSpacer } from '@artegeie/design-system/mona'
 *
 * const App = () => console.log(lSpacer); // "30px"
 * ```
 */
export const lSpacer: string = MonaBS.lSpacer;

/** 
 * @remarks returns xl spacer value
 * @example
 * ```javascript
 * import { xlSpacer } from '@artegeie/design-system/mona'
 *
 * const App = () => console.log(xlSpacer); // "60px"
 * ```
 */
export const xlSpacer: string = MonaBS.xlSpacer;

// tslint:disable-next-line:interface-over-type-literal
export type Textfield_Props<T1> = {
  readonly ariaLabel?: string; 
  readonly autoComplete?: Atom_Textfield_Mona_Mona_autoComplete; 
  readonly onChange?: (_1:T1) => void; 
  readonly placeholder?: string; 
  readonly readOnly?: boolean; 
  readonly required?: boolean; 
  readonly title?: string; 
  readonly type_?: string; 
  readonly value?: string
};

/** 
 * @example
 * ```javascript
 * import { Textfield } from '@artegeie/design-system/mona'
 *const autoComplete= "email" ////  values allowed:  email | Off |  newPassword |  currentPassword
 * const App = () => <Textfield type_="email" required=true placeholder="Adresse e-mail" autoComplete />
 * ````
 */
export const Textfield: React.FC<{
  readonly ariaLabel?: string; 
  readonly autoComplete?: Atom_Textfield_Mona_Mona_autoComplete; 
  readonly onChange?: (_1:any) => void; 
  readonly placeholder?: string; 
  readonly readOnly?: boolean; 
  readonly required?: boolean; 
  readonly title?: string; 
  readonly type_?: string; 
  readonly value?: string
}> = MonaBS.Textfield;

// tslint:disable-next-line:interface-over-type-literal
export type Link_Props = {
  readonly href: Atom_Box_href; 
  readonly label: string; 
  readonly onClick?: Atom_Box_onClick; 
  readonly target?: Atom_Box_target; 
  readonly variant?: Atom_Cta_Mona_Link_monaLinkStyle
};

/** 
 * @example
 * ```javascript
 * import { Link } from '@artegeie/design-system/mona'
 *
 * const App = () => <Link label="Label" href="href" />
 * ````
 */
export const Link: React.FC<{
  readonly href: Atom_Box_href; 
  readonly label: string; 
  readonly onClick?: Atom_Box_onClick; 
  readonly target?: Atom_Box_target; 
  readonly variant?: Atom_Cta_Mona_Link_monaLinkStyle
}> = MonaBS.Link;

// tslint:disable-next-line:interface-over-type-literal
export type Dropdown_Props = {
  readonly autoComplete?: Atom_Select_autoComplete; 
  readonly items: Type_Dropdown_Item_t[]; 
  readonly name: Atom_Box_name; 
  readonly onChange: (_1:Type_Dropdown_Item_t) => void; 
  readonly value?: Type_Dropdown_Item_value; 
  readonly variant?: Organism_Dropdown_Ds_Select_variant
};

/** 
 * @example
 * ```javascript
 * import { Dropdown } from '@artegeie/design-system/mona'
 *
 * const items = [
 *    { label: 'labelOne', value: 'one' },
 *    { label: 'labelTwo', value: 'two' }
 * ]
 * const handlerFunction = ({label, value}) => myHandlerFunction(label, value)
 * const autoComplete = "off" ////  values allowed:  [honorificPrefix |birthdayDay |birthdayMonth |birthdayYear |countryName| off ]
 * const App = () => <Dropdown name="myDropdown" items=items value={currentItem.value} onChange={handlerFunction} autoComplete/>
 * ````
 */
export const Dropdown: React.FC<{
  readonly autoComplete?: Atom_Select_autoComplete; 
  readonly items: Type_Dropdown_Item_t[]; 
  readonly name: Atom_Box_name; 
  readonly onChange: (_1:Type_Dropdown_Item_t) => void; 
  readonly value?: Type_Dropdown_Item_value; 
  readonly variant?: Organism_Dropdown_Ds_Select_variant
}> = MonaBS.Dropdown;

// tslint:disable-next-line:interface-over-type-literal
export type Modal_Props = {
  readonly children?: React.ReactNode; 
  readonly id: string; 
  readonly isOpen: boolean; 
  readonly onClose: UseToggle_close; 
  readonly title: string
};

export const Modal: React.FC<{
  readonly children?: React.ReactNode; 
  readonly id: string; 
  readonly isOpen: boolean; 
  readonly onClose: UseToggle_close; 
  readonly title: string
}> = MonaBS.Modal;

// tslint:disable-next-line:interface-over-type-literal
export type DatePicker_Props = {
  readonly days: Type_Dropdown_Item_t[]; 
  readonly initialValues?: Type_DatePicker_state; 
  readonly months: Type_Dropdown_Item_t[]; 
  readonly onChange: (_1:Type_DatePicker_state) => void; 
  readonly years: Type_Dropdown_Item_t[]
};

/** 
 * @example
 * ```javascript
 * import { DatePicker } form '@artegeie/design-system/mona'
 *
 * const handlerFunction = ({day, month, year}) => myHandlerFunction(day, month, year)
 * const days = [{label: '1', value: '1'},{label: '2', value: '2'},{label: '3', value: '3'}]
 * const months = [{label: 'January', value: '1'}, {label: 'February', value: '2'}]
 * const years = [{label: '1991', value: '1991'},{label: '1992', value: '1992'}]

 * const App = () => <DatePicker onChange={handlerFunction} days=days months=months years=years />
 * ````
 *  */
export const DatePicker: React.FC<{
  readonly days: Type_Dropdown_Item_t[]; 
  readonly initialValues?: Type_DatePicker_state; 
  readonly months: Type_Dropdown_Item_t[]; 
  readonly onChange: (_1:Type_DatePicker_state) => void; 
  readonly years: Type_Dropdown_Item_t[]
}> = MonaBS.DatePicker;

// tslint:disable-next-line:interface-over-type-literal
export type Checkbox_Props = {
  readonly checked?: boolean; 
  readonly id: Atom_Box_htmlFor; 
  readonly label: JSX.Element; 
  readonly onClick: (_1:boolean) => void; 
  readonly required?: boolean
};

export const Checkbox: React.FC<{
  readonly checked?: boolean; 
  readonly id: Atom_Box_htmlFor; 
  readonly label: JSX.Element; 
  readonly onClick: (_1:boolean) => void; 
  readonly required?: boolean
}> = MonaBS.Checkbox;

// tslint:disable-next-line:interface-over-type-literal
export type EventInfo_Props = {
  readonly dateEvent: string; 
  readonly linkInfo: Molecule_EventInfo_link; 
  readonly linkTerms: Molecule_EventInfo_link; 
  readonly location: string
};

export const EventInfo: React.FC<{
  readonly dateEvent: string; 
  readonly linkInfo: Molecule_EventInfo_link; 
  readonly linkTerms: Molecule_EventInfo_link; 
  readonly location: string
}> = MonaBS.EventInfo;

// tslint:disable-next-line:interface-over-type-literal
export type Header_Props = {
  readonly initEvents: Entry_Mona_Header_initEvents; 
  readonly languages: Context_I18n_alternativeLanguages; 
  readonly locale?: Type_Common_language; 
  readonly myArteBaseUrl?: string
};

export const Header: React.FC<{
  readonly initEvents: Entry_Mona_Header_initEvents; 
  readonly languages: Context_I18n_alternativeLanguages; 
  readonly locale?: Type_Common_language; 
  readonly myArteBaseUrl?: string
}> = function Mona_Header(Arg1: any) {
  const $props = {initEvents:function (ArgonLogin: any, ArgonLogout: any) {
      const result1 = Arg1.initEvents({onLogin:ArgonLogin, onLogout:ArgonLogout});
      return result1
    }, languages:Arg1.languages, locale:Arg1.locale, myArteBaseUrl:Arg1.myArteBaseUrl};
  const result = React.createElement(MonaBS.Header, $props);
  return result
};

/** 
 * @category User
 *
 * @remarks If the user is connected/anonymous, return the token from the local storage.
 * Otherwise return null/undefined
 *
 */
export const getToken: () => (null | undefined | User_Type_token) = function () {
  const result = MonaBS.getToken();
  return (result == null ? result : typeof(result) === 'object'
    ? result.TAG===0
      ? {tag:"Anonymous", value:result._0}
      : {tag:"Connected", value:result._0}
    : $$toJS606672800[result])
};
